import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRSIC_SAL_NVGL;

export default {
  read(payload) {
    return baseApi.post(resource, payload);
  },
};
